<template>
    <div class="flex items-center justify-center w-full h-full min-h-20">
        <hts-loading :loading="loading">
            <template v-if="!list.length">
                <p>
                    Hiện tại chưa có hoạt động nào.
                </p>
            </template>
            <ul
                v-else
                class="w-full overflow-auto h-full px-2">
                <template
                    v-for="(alert, index) in list"
                    :key="index">
                    <li class="border-l-2 border-green-500 py-3">
                        <div class="relative">
                            <span class="absolute top-[14px] -left-[6px] w-3 h-3 rounded-full inline-block bg-blue-400" />
                        </div>
                        <div class="px-2 flex items-center gap-2 h-[40px]">
                            <span class="text-blue-500">
                                {{ $formatters.datetime(alert.createdAt) }}
                            </span>
                            <hts-user
                                v-if="alert.createdBy"
                                :id="alert.createdBy"
                                size="mini"
                                show-info />
                            <span
                                v-else
                                class="text-green-500 font-medium select-none border rounded px-1 border-green-500">
                                SYSTEM
                            </span>
                        </div>
                        <div class="px-2 my-2 flex items-center whitespace-nowrap flex-wrap">
                            <template v-if="alert.type === 'process_alert_status'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:
                                </span><alert-status
                                    :status="alert.oldData"
                                    class="mx-1" />
                                <div class="inline-flex">
                                    <hts-icons icon-name="hi-arrow-long-right-icon" />
                                </div>
                                <alert-status
                                    :status="alert.newData"
                                    class="mx-1" />
                            </template>
                            <template v-else-if="alert.type === 'actual_time_updated'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:
                                </span>
                                <span class="uppercase mx-1 font-bold">
                                    {{ alert.data?.name }}
                                </span>
                                <span class="text-gray-500 line-through">
                                    {{ $formatters.datetime(alert.oldData || '...') }}
                                </span>
                                <div class="inline-flex mx-1">
                                    <hts-icons icon-name="hi-arrow-long-right-icon" />
                                </div>
                                <span class="text-green-500">
                                    {{ $formatters.datetime(alert.newData || '...') }}
                                </span>
                            </template>
                            <template v-else-if="alert.type === 'driver_gps_error'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:
                                </span>
                                <span class="inline-flex align-middle text-error-500">
                                    {{ alert.data?.message || '' }}:
                                </span>
                            </template>
                            <template v-else-if="alert.type === 'driver_not_start'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:
                                </span>
                                <span class="inline-flex align-middle text-error-500">
                                    {{ alert.data?.message || '' }}:
                                </span>
                            </template>
                            <template v-else-if="alert.type === 'PLANNING_CHANGED'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:
                                </span>
                                <span class="inline-flex align-middle text-error-500">
                                    {{ alert.data?.message || '' }}:
                                </span>
                            </template>
                            <template v-else-if="alert.type === 'JOURNEY_ALERT_SKIPPED'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:&nbsp;Bỏ qua cảnh báo
                                </span>
                                <span class="inline-flex align-middle text-error-500">
                                    {{ alert.data?.message || '' }}:
                                </span>
                            </template>
                            <template v-else-if="alert.type === 'JOURNEY_SCHEDULE_ALERT_SKIPPED'">
                                <span class="inline-flex align-middle">
                                    Chặng {{ alert.data?.journeyCode || '#' }}:&nbsp;Bỏ qua cảnh báo
                                </span>
                            </template>
                        </div>
                    </li>
                </template>
            </ul>
        </hts-loading>
    </div>
</template>

<script lang="ts" setup>
import AlertStatus from '@/pages/trucker-[id]/monitoring/-components/alert-status.vue'

const props = defineProps({
  journeyId: String as PropType<string | null>
})
const loading = ref(false)
const { journeyId } = toRefs(props)

const list = ref<any[]>([])

const getAlerts = () => {
  list.value = []
  if (!journeyId?.value) {
    return
  }
  loading.value = true
  $api($urlPartner.monitoring.journey.activities.get, { uriParams: { ID: journeyId.value } }).then(({ data }: any) => {
    list.value = (data?.value || {}).data || []
    loading.value = false
  })
}
onMounted(() => {
  getAlerts()
})
const refresh = $lodash.debounce(getAlerts, 500)
defineExpose({ refresh })
</script>
